import { render, staticRenderFns } from "./batchCheckDialog.vue?vue&type=template&id=70306c30&"
import script from "./batchCheckDialog.vue?vue&type=script&lang=js&"
export * from "./batchCheckDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports